export const CHECKOUT_EXPIRE_MESSAGES = {
	statusChange:
		'This bid has an active online payment link emailed to the customer. Changing the status will expire that link so it can no longer be used. Continue?',
	changeOrder:
		'The current bid has an active online payment link emailed to the customer. Sending this change order will withdraw that bid and expire the link. Continue?',
};

export const CHECKOUT_EXPIRE_CONFIRM_OPTIONS = {
	title: 'Invalidate payment link?',
	confirmText: 'Continue',
	confirmColor: 'primary',
};

export const getCheckoutExpireConfirmOptions = (variant = 'statusChange') => ({
	message: CHECKOUT_EXPIRE_MESSAGES[variant],
	...CHECKOUT_EXPIRE_CONFIRM_OPTIONS,
});
